<nav class="navbar" role="navigation" aria-label="main navigation">
   <div class="navbar-brand">
      <a class="navbar-item" href="#">
         <img src="../../assets/images/HG-logo-330px.png" />
      </a>

      <a
         role="button"
         #navBurger
         (click)="toggleNavbar()"
         class="navbar-burger burger"
         (click)="toggleClass()"
         [ngClass]="{ 'is-active': isActiveStatus }"
         aria-label="menu"
         aria-expanded="false"
         data-target="navbarBasic"
      >
         <span aria-hidden="true"></span>
         <span aria-hidden="true"></span>
         <span aria-hidden="true"></span>
      </a>
   </div>

   <div
      id="navbarBasic"
      #navMenu
      class="navbar-menu"
      (click)="toggleClass()"
      [ngClass]="{ 'is-active': isActiveStatus }"
   >
      <div class="navbar-start">
         <a class="navbar-item" routerLink="dashboard"> Dashboard </a>

         <a class="navbar-item" routerLink="pos"> Satış </a>
         <a class="navbar-item" routerLink="purchase"> Satın Alma </a>
         <a class="navbar-item" routerLink="search"> Arama </a>
         <a class="navbar-item" routerLink="test"> Test </a>
         <a class="navbar-item" routerLink="status"> Durum </a>

         <div class="navbar-item has-dropdown is-hoverable">
            <a class="navbar-link"> Ürünler </a>

            <div class="navbar-dropdown">
               <a class="navbar-item" routerLink="item-list"> Liste </a>
               <a class="navbar-item" routerLink="deals"> Günlük rapor </a>
               <a class="navbar-item"> Jobs </a>
               <a class="navbar-item"> Contact </a>
               <hr class="navbar-divider" />
               <a class="navbar-item"> Report an issue </a>
            </div>
         </div>
      </div>

      <div class="navbar-end">
         <ng-container *ngIf="(pictureUrl$ | async) as pictureUrl">
            <figure class="navbar-item image is-64x64">
               <img class="responsive-img" [src]="pictureUrl" />
            </figure>
         </ng-container>

         <a class="navbar-item" routerLink="user/login" *ngIf="isLoggedOut$ | async"> Giriş </a>
         <a class="navbar-item" (click)="onLogout()" *ngIf="isLoggedIn$ | async"> Çıkış </a>
      </div>
   </div>
</nav>
